module.exports = __webpack_public_path__ + "img/file_gray.2fc5c8d5.svg";